import { render, staticRenderFns } from "./PagesOfVideo.vue?vue&type=template&id=9458da72&scoped=true&"
import script from "./PagesOfVideo.vue?vue&type=script&lang=js&"
export * from "./PagesOfVideo.vue?vue&type=script&lang=js&"
import style0 from "./PagesOfVideo.vue?vue&type=style&index=0&id=9458da72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9458da72",
  null
  
)

/* custom blocks */
import block0 from "./PagesOfVideo.vue?vue&type=custom&index=0&blockType=i18nf"
if (typeof block0 === 'function') block0(component)

export default component.exports